module.exports = __webpack_public_path__ + "static/img/Travis_Boak_desktop.b0c2225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Travis_Boak_desktop.jpg
// module id = RaWs
// module chunks = 0